var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { width: "100%" } }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "container app-container" }, [
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("input", {
            staticStyle: { display: "block", width: "100px", margin: "auto" },
            attrs: { type: "file", id: "uploadTest" }
          }),
          _vm._v(" "),
          _c("vue-dropzone", {
            ref: "dropzoneInstance",
            staticClass: "uploadTable",
            staticStyle: { width: "100%" },
            attrs: { id: "dzUploadControl", options: _vm.dropzoneOptions },
            on: {
              "vdropzone-sending": [_vm.sendingEvent, _vm.vueDropzoneSending],
              "vdropzone-canceled": _vm.vueDropzoneCanceled,
              "vdropzone-success": _vm.vueDropzoneSuccess,
              "vdropzone-error": _vm.vueDropzoneError
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table-uploads-block" },
            [
              _c(
                "b-card-body",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _vm.showCheckingMessage
                          ? _c("h6", { staticClass: "title" }, [
                              _vm._v(_vm._s(_vm.fileCheckingMessage)),
                              _c("i", {
                                staticClass: "fas fa-sync fa-spin",
                                staticStyle: { color: "darkorange" }
                              })
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("b-col", [
                        _c(
                          "h6",
                          {
                            staticClass: "title",
                            staticStyle: { float: "right" }
                          },
                          [
                            _vm._v(
                              "Tamanho do arquivo: " +
                                _vm._s(
                                  _vm.FormatBytes(
                                    _vm.dropzoneOptions.maxFilesize
                                  )
                                ) +
                                " | Número de linhas: " +
                                _vm._s(_vm.dropzoneOptions.maxRows) +
                                " | Número de colunas: " +
                                _vm._s(_vm.dropzoneOptions.maxColumns)
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { key: "my-upload-files-" + _vm.tableDataKey },
                [
                  _c("b-table", {
                    attrs: {
                      id: "my-upload-files",
                      striped: "",
                      hover: "",
                      small: "",
                      items: _vm.listFiles,
                      fields: _vm.listFilesSettings
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "cell(cMime)",
                        fn: function(data) {
                          return [
                            _c("i", { class: _vm.fileIcon(data.item.cName) }),
                            _vm._v(
                              "\n                " +
                                _vm._s(data.item.cName) +
                                "\n              "
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(actions)",
                        fn: function(data) {
                          return [
                            _c(
                              "b-dropdown",
                              {
                                staticClass: "file-item-actions",
                                attrs: {
                                  id: _vm.formatClass(data.item.cName),
                                  variant:
                                    "default btn-round icon-btn borderless md-btn-flat hide-arrow",
                                  size: "sm"
                                }
                              },
                              [
                                _c("template", { slot: "button-content" }, [
                                  _c("i", { staticClass: "fas fa-ellipsis-h" })
                                ]),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function($event) {
                                        return _vm.showPageConfigTable(
                                          data.item
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Criar camada")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-dropdown-item",
                                  {
                                    attrs: { href: "javascript:void(0)" },
                                    on: {
                                      click: function($event) {
                                        return _vm.deleteFile(data.item)
                                      }
                                    }
                                  },
                                  [_vm._v("Remover tabela")]
                                ),
                                _vm._v(" "),
                                false
                                  ? _c(
                                      "b-dropdown-item",
                                      { attrs: { href: "javascript:void(0)" } },
                                      [_vm._v("Visualizar tabela")]
                                    )
                                  : _vm._e()
                              ],
                              2
                            )
                          ]
                        }
                      },
                      {
                        key: "cell(dtAddIn)",
                        fn: function(data) {
                          return [
                            _c("span", { staticClass: "date" }, [
                              _c("i", { staticClass: "icon-date" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/icons/calendar.svg")
                                  }
                                })
                              ]),
                              _vm._v(
                                _vm._s(_vm.formatDate(data.item.dtAddIn)) +
                                  "\n                  "
                              ),
                              _c("i", { staticClass: "icon-date" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/icons/clock-circular.svg")
                                  }
                                })
                              ]),
                              _vm._v(
                                _vm._s(_vm.formatHora(data.item.dtAddIn)) +
                                  "\n                "
                              )
                            ])
                          ]
                        }
                      },
                      {
                        key: "cell(nSize)",
                        fn: function(data) {
                          return [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.FormatBytes(data.item.nSize)) +
                                "\n              "
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("b-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.perPage !== 0,
                    expression: "perPage !== 0"
                  }
                ],
                attrs: {
                  "total-rows": _vm.totalRows,
                  "per-page": _vm.perPage,
                  "aria-controls": "my-upload-files"
                },
                on: { change: _vm.handlePageChange },
                model: {
                  value: _vm.currentPage,
                  callback: function($$v) {
                    _vm.currentPage = $$v
                  },
                  expression: "currentPage"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "header",
      {
        staticClass: "wrapper-header gradient",
        attrs: { id: "wrapper-header", role: "main" }
      },
      [
        _c("div", { staticClass: "container app-container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "wrapper-header-block col-12" }, [
              _c("h2", { staticClass: "title" }, [_vm._v("Uploads")])
            ])
          ])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }